export const adornmentStyle = {
  p: '4px',
  borderRadius: 2,
  backgroundColor: 'success.main',
}
